/* @jsx jsx */
import { css, jsx } from '@emotion/react';
import { TabPanel, TypeRampV2, sizes, Link } from '@smartsheet/lodestar-core';
import { ExternalIcon } from '@smartsheet/lodestar-icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import UnderConstruction from '../../../../../images/under-construction.svg';
import { switchToLegacyView } from '../../../../../services/ducks/workflowDuck/workflowDuck';
import { IconButton } from '../../../../common/IconButton';

export const Integrations = () => {
  const { t: translate } = useTranslation();
  const spacerStyle = css`
    height: 80px;
  `;
  const containerStyle = `
display: flex;
flex-direction: column;
align-items: center;
`;
  const dispatch = useDispatch();

  return (
    <TabPanel css={css(containerStyle)}>
      <div css={spacerStyle}></div>
      <img
        css={css`
          width: 120px;
        `}
        src={UnderConstruction}
        alt={translate('designer:triggerPanel:integrations:title')}
      />
      <TypeRampV2
        system="lodestar"
        variant="headlineSmall"
        css={css`
          margin-top: ${sizes.large}px;
        `}
      >
        {translate('designer:triggerPanel:integrations:title')}
      </TypeRampV2>
      <div css={css(containerStyle + `margin-top:${sizes.medium}px;`)}>
        <TypeRampV2 system="lodestar" variant="bodyText">
          {translate('designer:triggerPanel:integrations:subtitle')}
        </TypeRampV2>
        <div
          css={css`
            margin-top: ${sizes.xxSmall}px;
          `}
        >
          <TypeRampV2
            system="lodestar"
            variant="bodyText"
            css={css`
              margin-top: ${sizes.medium}px;
            `}
          >
            {translate('designer:triggerPanel:integrations:text')}
          </TypeRampV2>
          <Link
            css={css`
              font-size: 13pt;
            `}
            appearance={'button-borderless'}
            onClick={() => {
              dispatch(switchToLegacyView());
            }}
          >
            {translate('designer:triggerPanel:integrations:legacyView')}
          </Link>
        </div>
      </div>
      <div css={spacerStyle}></div>
      <a
        href={`${window.location.origin}#/dashboard/plugins`}
        target={'_blank'}
        rel={'noreferrer'}
      >
        <IconButton iconBefore={<ExternalIcon />}>
          {translate('designer:triggerPanel:integrations:button')}
        </IconButton>
      </a>
    </TabPanel>
  );
};
